import { render, staticRenderFns } from "./ManageSkus.vue?vue&type=template&id=6c70a283&"
import script from "./ManageSkus.vue?vue&type=script&lang=ts&"
export * from "./ManageSkus.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSkus.vue?vue&type=style&index=0&id=6c70a283&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports